export const carouselFocus = (value: number, index: number, count: number) => {
	'worklet';

	if (count <= 1) return 1;

	const half = count / 2;
	const wrapped = ((((value - index + half) % count) + count) % count) - half;

	return 1 - Math.min(Math.abs(wrapped), 1);
};

export default carouselFocus;
